<template>
  <div class="homeDesc">
    <div class="container">
      <h3 class="title">We strive to provide our clients with user-friendly online trading experience by demonstrating
        our commitment to the highest business standards and ethics. We aim at all times, to comply with all applicable
        national and international regulatory requirements.</h3>

      <div class="desCont">
        <a v-for="item in descList" :key="item.id" class='descItem' :href="item.link" target='_blank' rel='noreferrer'>
          <img src='@/assets/image/PDF.svg' alt='' width="64" height="64" />
          <span class='descTitle'>
            {{ item.title }}
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'homeDesc',
  data() {
    return {
      descList: [
        {
          title: 'Risk Disclosure Notice',
          link: "/doc/Risk Disclosure Notice.pdf",
        },
        {
          title: 'Privacy Policy',
          link: "doc/Privacy Policy.pdf",
        },
        {
          title: 'Conflict of Interest Policy',
          link: "/doc/Conflict of Interest Policy V2.pdf",
        },
        {
          title: 'Complaint Notice',
          link: "/doc/Complaint Notice.pdf",
        },
        {
          title: 'TOB 2025',
          link: "/doc/TOB 2025.pdf",
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.homeDesc {
  padding: 80px 0 28px;

  .container {
    margin: 0 auto;
    max-width: 1200px;
    color: #000;

    .title {
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      margin-bottom: 64px;
      padding: 0 100px;
    }

    .desCont {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;

      .descItem {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 28px 24px 28px 20px;
        max-width: 384px;
        height: 120px;
        border: 1.5px solid #fff;
        border-radius: 12px;
        background-color: #fff;
        box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);
        color: #000;
        text-decoration: none;

        &:hover {
          background-color: #fff;
        }

        .descTitle {
          font-size: 20px;
          line-height: 32px;
        }
      }
    }
  }
}


@media screen and (min-width: 769px) and (max-width: 1200px) {
  .homeDesc {
    .container {
      max-width: 100%;

      .desCont {
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .homeDesc {
    padding: 40px 0 28px;

    .container {
      width: 100% !important;
      padding: 0 16px;

      .title {
        font-size: 14px;
        line-height: 20px;
        padding: 0;
        margin-bottom: 32px;
      }

      .desCont {
        grid-template-columns: repeat(1, 1fr);
        gap: 24px;

        .descItem {
          .descTitle {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>